<p [ngSwitch]="data.messageId">
  <span *ngSwitchCase="0" i18n="@@DialogErrorInternal">Si è verificato un problema durante l'invio della richiesta, contattare il customer service</span>
  <span *ngSwitchCase="1" i18n="@@DialogErrorData">Si è verificato un problema durante l'invio della richiesta, contattare il customer service</span>
  <span *ngSwitchCase="2" i18n="@@DialogOk">Richiesta inviata con successo</span>
</p>
<div style="text-align: right">
  <button mat-raised-button (click)="closeDialog()" i18n="@@DialogClose">Chiudi</button>
</div>



// WEBPACK FOOTER //
// ./src/app/confirm-dialog/confirm-dialog.html